import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import es from './locales/es.json'
import ca from './locales/ca.json'
import fr from './locales/fr.json'
import ru from './locales/ru.json'

export type MessageLanguages = keyof typeof messages
export type MessageSchema = typeof messages['en']

const messages = {
  en,
  es,
  ca,
  fr,
  ru
}

/**
 * Detecta el idioma del navegador/dispositivo del usuario
 * @returns código de idioma soportado o 'es' por defecto
 */
const getBrowserLanguage = (): MessageLanguages => {
  // Primero verificar si hay un idioma guardado en localStorage
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage && savedLanguage in messages) {
    return savedLanguage as MessageLanguages
  }

  // Detectar idioma del navegador
  const browserLang = navigator.language || (navigator as any).userLanguage
  
  // Extraer solo el código de idioma (ej: 'es-ES' -> 'es', 'en-US' -> 'en')
  const langCode = browserLang.split('-')[0].toLowerCase()
  
  // Verificar si el idioma está soportado
  if (langCode in messages) {
    return langCode as MessageLanguages
  }
  
  // Idioma por defecto si no se encuentra coincidencia
  return 'es'
}

const i18n = createI18n<[MessageSchema], MessageLanguages>({
  legacy: false,
  locale: getBrowserLanguage(), // Detectar idioma automáticamente
  fallbackLocale: 'en',
  messages,
  globalInjection: true
})

export default i18n